const ossApi = '/ossApi'
// let hostname = window.location.hostname
const encryptionJS = require('../../assets/js/encryption');
// 社工
let areaCode = '65'
let tenantCode = '650000000000000001'
let title = '新疆自治区党委社会工作部'
let imageUrl = ossApi + '/szsg'
let username = encryptionJS.aesDecrypt('RUMLXJfB2RRbHHny6xFZFw==')
let password = encryptionJS.aesDecrypt('KaWzx1B8W/xxgSVlywH3Ww==')
let serviceUrl = 'http://117.190.86.198:9000/xjsgb'  //履职服务平台
let systemType = 'other'
switch (process.env.NODE_ENV) {
  case 'development': // 开发环境
    break
  default:
    break
}
export default {
  ossApi,
  tenantCode,
  title,
  imageUrl,
  username,
  password,
  areaCode,
  systemType
}
